import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateBankAccountTemplate } from "../api/queries";
import { BankAccountTemplateForm } from "../ui/BankAccountTemplateForm";

export function BankAccountTemplateCreatePage() {
  const nav = useNavigate({
    from: "/app/performance/bank-account-templates/create",
  });
  const createTemplate = useCreateBankAccountTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບບັນຊີ",
              to: "/app/performance/bank-account-templates",
            },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມແມ່ແບບ</h2>
          <p className="text-muted-foreground">ສ້າງແມ່ແບບຂໍ້ມູນບັນຊີທະນາຄານໃໝ່</p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          <BankAccountTemplateForm
            onSubmit={async (vals) => {
              try {
                const created = await createTemplate.mutateAsync(vals);
                nav({
                  to: "/app/performance/bank-account-templates/$id/edit",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() =>
              nav({ to: "/app/performance/bank-account-templates" })
            }
            submitting={createTemplate.isPending}
          />
        </div>
      </Main>
    </>
  );
}
